module.exports = __webpack_public_path__ + "media/qidong.3513217d.mp3";